import { useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-8">
          <Logo size="large" theme="light" />
        </div>

        <div className="w-20 h-20 rounded-full bg-slate-100 flex items-center justify-center mx-auto mb-6">
          <svg width="36" height="36" fill="none" stroke="#64748b" strokeWidth="1.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-[#1e293b] mb-2">Page not found</h1>
        <p className="text-[#64748b] text-sm mb-8 leading-relaxed">
          The audit report you're looking for has expired or doesn't exist.
        </p>

        <button
          onClick={() => navigate("/audit")}
          className="inline-flex items-center gap-2 text-white font-bold py-3 px-8 rounded-xl text-sm transition-colors"
          style={{ background: "#6366f1" }}
          data-testid="run-new-audit-btn"
          onMouseOver={e => { e.currentTarget.style.background = "#4f46e5"; }}
          onMouseOut={e => { e.currentTarget.style.background = "#6366f1"; }}
        >
          Run a New Free Audit
          <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </button>
      </div>
    </div>
  );
}
